"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AggregationFunction;
(function (AggregationFunction) {
    AggregationFunction[AggregationFunction["SUM"] = 1] = "SUM";
    AggregationFunction[AggregationFunction["COUNT"] = 1] = "COUNT";
    AggregationFunction[AggregationFunction["CONCAT"] = 1] = "CONCAT";
    AggregationFunction[AggregationFunction["FIRST"] = 3] = "FIRST";
    AggregationFunction[AggregationFunction["LAST"] = 3] = "LAST";
    AggregationFunction[AggregationFunction["MAX"] = 2] = "MAX";
    AggregationFunction[AggregationFunction["MIN"] = 2] = "MIN";
    AggregationFunction[AggregationFunction["DOCUMENTJSON"] = 1] = "DOCUMENTJSON";
    AggregationFunction[AggregationFunction["AVG"] = 2] = "AVG";
})(AggregationFunction = exports.AggregationFunction || (exports.AggregationFunction = {}));
//# sourceMappingURL=aggregation-type-function.js.map